// --------------------------------------------------------------------------
// Simple tabs
// --------------------------------------------------------------------------
// Author:      Thomas Jeatt
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;
    var simpleTabsControls = context.find('[data-binding="simple-tabs-controls"]');
    var simpleTabsLink = context.find('[data-binding="simple-tabs-link"]');
    var simpleTabsContent = context.find('[data-binding="simple-tabs-content"]');

    function init() {

        /// On load add selected state to first tab and its content
        simpleTabsLink.filter(':first').addClass('is-selected');
        simpleTabsContent.filter(':first').addClass('is-visible');

        function deselectTab() {
            context.find('.is-selected').removeClass('is-selected');
            context.find('.is-visible').removeClass('is-visible');
        }

        function selectTab(selectedTab) {
            var simpleTabsTarget = selectedTab.data('simple-tabs-target');
            var simpleTabsContent = context.find('[data-simple-tabs-content="' + simpleTabsTarget + '"]');

            selectedTab.addClass('is-selected');
            simpleTabsContent.addClass('is-visible');
        }

        //Click event for tabs to show content
        simpleTabsControls.on('click', '[data-binding="simple-tabs-link"]', function (e) {
            e.preventDefault();
            deselectTab();
            selectTab($(this));
        });

        //Add accessible display
        context.find('.simple-tabs-content *').on({
            focus: function focus() {
                var focusedTab = $(this).parents('.simple-tabs-content').data('simple-tabs-content');
                var focusedContent = context.find('[data-simple-tabs-content="' + focusedTab + '"]');

                deselectTab();

                simpleTabsControls.find(simpleTabsLink).each(function () {
                    if ($(this).data('simple-tabs-target') === focusedTab) {
                        $(this).addClass('is-selected');
                    }
                });

                focusedContent.addClass('is-visible');
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/simple-tabs.js
// module id = 262
// module chunks = 0